import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'ambanji_cookie_ack_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/portal') || location.pathname === '/login';

  useEffect(() => {
    if (isAdminRoute) return;
    try {
      const acked = localStorage.getItem(STORAGE_KEY);
      if (!acked) {
        // Small delay so it doesn't fight with the page load
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // no-op if storage blocked
    }
  }, [isAdminRoute]);

  const ack = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (e) {}
    setVisible(false);
  };

  if (!visible || isAdminRoute) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60]">
      <div className="rounded-2xl bg-stone-900 text-stone-100 shadow-2xl border border-stone-800 p-5 flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-[#F97316]/15 flex items-center justify-center flex-shrink-0">
          <Cookie size={18} className="text-[#F97316]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13.5px] leading-relaxed">
            We use a couple of essential cookies to keep you signed in and secure the checkout. No ad tracking, no third-party analytics.
          </p>
          <div className="mt-3 flex items-center gap-3">
            <button
              onClick={ack}
              className="px-4 py-2 text-[12px] font-bold text-stone-900 bg-white rounded-lg hover:bg-stone-100 transition"
            >
              Got it
            </button>
            <Link to="/privacy" className="text-[12px] font-semibold text-stone-300 hover:text-white underline underline-offset-2">
              Privacy Policy
            </Link>
          </div>
        </div>
        <button onClick={ack} className="text-stone-500 hover:text-stone-200 transition" aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
